/**
 * Page À propos et principes partagés avec l'accueil.
 *
 * Textes de la maquette. Les composants du labo et la date de mise à jour
 * sont des EXEMPLES, à tenir à jour avec ce qui tourne réellement.
 */

export const intro = {
  title: 'Ingénieur réseau.',
  /** Seconde ligne ; la partie après `|` est le mot d'accent surligné. */
  title2: "J'installe l'IA dans un labo, |et je mesure.",
  lead: "AICECAP, c'est AI et icecap : l'outil mis au travail, et le sommet qu'on gravit épisode après épisode. Je documente un seul projet qui grandit, un pipeline de veille, en publiant uniquement ce qui a tourné chez moi.",
  facts: [
    { label: 'Métier', value: 'Réseau et sécurité' },
    { label: 'Cadence', value: '1 épisode par mois' },
  ],
};

/** Les trois règles : accueil (« Un labo personnel ») et À propos (« La règle »). */
export const principes = [
  { num: '01', title: 'Tout a tourné', body: 'Chaque article contient une commande lancée, une configuration, un chiffre mesuré ou une panne.' },
  { num: '02', title: 'Tout est daté', body: 'Les outils changent vite. Chaque épisode affiche sa date et les versions testées.' },
  { num: '03', title: 'Tout est publié', body: 'Prompts, scripts et workflows de chaque phase sont sur un repo git public.' },
];

/** « Ce que je fais tourner » : la page qui se remplit au fil des épisodes. */
export const labo = {
  updated: '2027-01-14',
  components: [
    { state: 'actif', label: 'Actif, épisode 03', title: 'API Anthropic', body: 'Résumé et classement des éléments de veille, avec Tool Use.' },
    { state: 'actif', label: 'Actif, épisode 01', title: 'Claude Projects', body: 'Contexte permanent pour la rédaction : ton, charte, garde-fous.' },
    { state: 'actif', label: 'Actif, v0.3', title: 'pipeline.py', body: 'Collecte, résumé, sortie Markdown. Lancé à la main chaque semaine.' },
    { state: 'prevu', label: 'Épisode 06', title: 'n8n auto-hébergé', body: 'Planification hebdomadaire, secrets, sauvegarde du workflow.' },
    { state: 'prevu', label: 'Épisode 08', title: 'pgvector', body: 'Base vectorielle locale contre les doublons.' },
    { state: 'prevu', label: 'Épisode 09', title: 'Ollama, Hermes, Llama', body: 'Modèles locaux, comparés à Claude sur les mêmes tâches.' },
  ] as const,
};

export const gardeFous = [
  "Rien de l'employeur n'apparaît, même anonymisé. Seuls le labo personnel et les mandats clients servent de source.",
  'Tout tourne dans un labo segmenté, isolé de toute infrastructure professionnelle.',
  'Un épisode par mois, un Relevé par semaine. Quatre à six heures par mois, pas plus.',
  "Aucun article ne se termine par un appel à la prise de contact.",
];

export const contact = {
  lead: 'Une question sur un épisode, une idée d\'outil à tester, un mandat. Je réponds sous quelques jours.',
  subjects: ['Une question sur un épisode', "Une idée d'outil à tester", 'Un mandat', 'Autre'],
};
